import React from "react";
import { Modal } from "react-bootstrap";
import { useAppEventGameDetailSelector } from "src/_common/hooks/selectors/eventSelector";

interface OptionSelectionModalProps {
  onSuccess: (success: any) => void;
  onClose: (success: any) => void;
  shouldShow: boolean;
  optionDetails: any;
  skipAnswer: Function;
}

export default function OptionSelectionModal({
  onSuccess,
  onClose,
  shouldShow,
  optionDetails,
  skipAnswer,
}: OptionSelectionModalProps) {
  const eventGameDetailsSelector = useAppEventGameDetailSelector();
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Header>
          <h2 className="modal-header-text">Pick Your Answer</h2>
          <button type="button" className="btn-close" onClick={() => onClose(true)}></button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body">
            <h4 className="rider-name-content">
              {optionDetails?.contestant_avatar?.id || optionDetails?.contestant_dtls?.avatar?.id ? (
                <div className="rider-img-wrap">
                  <img
                    src={
                      optionDetails?.contestant_avatar?.id != 0
                        ? optionDetails?.contestant_avatar?.original
                        : optionDetails?.contestant_dtls?.avatar?.original
                    }
                  />
                </div>
              ) : null}

              <p>
                You selected <strong>{optionDetails?.answer_contestant || optionDetails?.contestant_dtls?.name}</strong>
              </p>
              <p>
                Tap ok to confirm.
                {/* <b>Once confirmed, your pick cannot be changed!</b> */}
              </p>
            </h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={() => onSuccess(true)}>
              Ok
            </button>
            {console.log({ eventGameDetailsSelector, optionDetails })}
            {eventGameDetailsSelector?.events?.user_answers?.find(
              (x: any) => x?.question_id == optionDetails?.question_id
            ) ? (
              <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={() => skipAnswer()}>
                Skip
              </button>
            ) : null}
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
